/* unplugin-vue-components disabled */import { render } from "./Offboarding.vue?vue&type=template&id=5fac60ca"
import script from "./Offboarding.vue?vue&type=script&lang=js"
export * from "./Offboarding.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__